import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import Loader from "../components/BlueButton/Loader.js";
import Api from "../Api.js";
import AddDayOff from "../components/DayOff/AddDayOff.js";
import {word} from "../word.js";
import Button from "../components/Button/Button.js";
import DayOffItem from "../components/DayOff/DayOffItem.js";
import {Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {dayOffAddLocalRequest} from "../store/actions/dayoff.js";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import Select from "react-select";
import {taskManagerRequest, accountantRequest} from "../store/actions/task.js";
import DatePicker from "react-datepicker";
import DayOffReport from "../components/DayOff/DayOffReport.js";

const profession = localStorage.getItem("profession");

function DayOff(props) {
    const [status] = useState(["Դիտարկում", 'Հաստատված', "Մերժված", "Բոլորը"])
    const navigate = useNavigate()
    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);
    const [loading, setLoading] = useState(null)
    const login = useSelector((state) => state.manager.employee);
    const dayOff = useSelector((state) => state.dayoff.dayoff);
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [showReport, setShowReport] = useState(false)
    const [activeId, setActiveId] = useState(3)
    const accountantArray = useSelector((state) => state.manager.accountantArray) || []


    useEffect(() => {
        (async () => {
            try {
                setLoading(true)
                let querystring = qs.stringify(query, {
                    arrayFormat: 'comma',
                    skipEmptyString: true,
                })
                setActiveId(query.approved ? query.approved : 3)
                const {data} = await Api.getDayOff(querystring)
                dispatch(dayOffAddLocalRequest(data))
                setLoading(false)
            } catch (e) {

            }
        })()
    }, [location.search])

    const handleFilter = (name, value) => {
        query[name] = value;
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`, {replace: true});
    }
    const handlePageChange = async (pageNumber) => {
        query.offset = pageNumber === 1 ? '' : (pageNumber - 1) * 10;
        query.page = pageNumber;
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        navigate(`?${querystring}`, {replace: true});
    };
    const allOptions = login.user_id === 86 || login.user_id === 2 || login.user_id === 1918 || login.user_id === 1024 ? [
        ...account.map(l => ({
            label: `${l.user.first_name} ${l.user.last_name}`,
            value: l.user_id
        })),
        ...managers.map(l => ({
            label: `${l.user.first_name} ${l.user.last_name}`,
            value: l.user_id
        }))
    ] : [...account.filter(a => accountantArray.includes(a.user_id)).map(l => ({
        label: `${l.user.first_name} ${l.user.last_name}`,
        value: l.user_id
    })),
        ...managers.filter(a => a.accountant_type === login.accountant_type).map(l => ({
            label: `${l.user.first_name} ${l.user.last_name}`,
            value: l.user_id
        }))];


    const selectedOptions = allOptions.filter(opt => query.creator?.includes(opt.value.toString()));
    return (
        <Wrapper>

            <div className='users'>

                {login.user_id !== 86 && login.user_id !== 1918 && login.user_id !== 1024 && <div className='plus-cont' onClick={() => setShow(true)}>
                    <span className="plus">+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>}

                {profession === 'manager' ? <div className='plus-cont' onClick={() => setShowReport(true)}>
                    <span className="tooltiptext"><i className="fa fa-download"/> {word.download}</span>
                </div> : null}
                <div className="tasks-buttons">
                    {status.map((l, i) => (
                        <Button
                            key={i}
                            buttonStyle={
                                +activeId !== i ? "middle-button task-button" : "task-button-active"
                            }
                            title={l}
                            onChangeValue={async () => {
                                await handleFilter('approved', i === 3 ? '' : i);
                                setActiveId(i);
                            }}
                        />
                    ))}
                </div>
                <div className="tasks-data tasks-data-manager">
                    <span className='tasks-data-item'>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={query.start_date_after || new Date().toISOString().split('T')[0]}
                        showMonthYearDropdown
                        onChange={(date) => handleFilter('start_date_after', date.toISOString().split('T')[0])}
                    />
                    </span>
                    <span className='tasks-data-item'>
                    <DatePicker
                        dateFormat="dd/MM/yyyy"
                        selected={query.start_date_before || new Date().toISOString().split('T')[0]}
                        showMonthYearDropdown
                        onChange={(date) => handleFilter('start_date_before', date.toISOString().split('T')[0])}
                    />
                    </span>

                    {profession === 'manager' ? <Select
                        styles={{
                            width: '50%',
                            control: (provided) => ({
                                ...provided,
                                border: 'none',
                                boxShadow: 'none', // Removes focus outline
                            }),
                        }}
                        // defaultValue={[]}
                        // isLoading={limitData.loader_orgs}
                        value={selectedOptions}
                        closeMenuOnSelect={false}
                        // components={animatedComponents}
                        options={allOptions}
                        placeholder='Մենեջերներ և աշխատակիցներ'
                        isMulti
                        onChange={(ev) => handleFilter('creator', ev.map(l => l.value))}
                    /> : null}
                </div>
                <div className="tasks-cont">
                    {loading ? <div className="loader-margin-small">
                        <Loader size={20}/>
                    </div> : dayOff?.results?.length ?
                        <Row className=" flex-row" style={{marginTop: 20}}>
                            {query?.id ? <Col md={6} >
                                <DayOffItem item={dayOff.results.find(l => +l.id === +query?.id)}/>
                            </Col> : dayOff.results.map((l, ind) => (
                                    <Col md={6} key={ind}>
                                        <DayOffItem item={l}/>
                                    </Col>
                                )
                            )}
                        </Row>
                        :
                        <div className="no_tasks text-center">{word.no_dayoff}</div>}
                    {dayOff?.count > 10 && (
                        <div className="d-flex justify-content-center">
                            <CustomPagination
                                currentPage={+query.page || 1}
                                totalItems={dayOff?.count || 0}
                                itemsPerPage={10}
                                totalPages={dayOff?.count ? Math.ceil(dayOff?.count / 10) : 0}
                                onPageChange={(newPage) => handlePageChange(newPage)}
                            />
                        </div>
                    )}
                </div>


            </div>

            {show ? <AddDayOff show={show} onHide={() => setShow(false)}/> : null}
            {showReport ?
                <DayOffReport allOptions={allOptions} show={showReport} onHide={() => setShowReport(false)}/> : null}
        </Wrapper>
    );
}

export default DayOff;